import { FC, SVGProps } from 'react'

const AppStreamIcon: FC<SVGProps<SVGSVGElement>> = ({ ...svgProps }) => {
  return (
    <svg
      id="Contenu"
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 0 170 153"
      {...svgProps}
    >
      <g>
        <g>
          <path
            // className="fill-current"
            d="M107.9,81.2l-30.3,18.1c-2.5,1.5-5.6-.3-5.6-3.2v-36.1c0-2.9,3.1-4.7,5.6-3.2l30.3,18.1c2.4,1.4,2.4,4.9,0,6.4Z"
          />
          <path
            className="fill-current"
            d="M159.6,14.4C144.7-4.8,25.6-4.8,10.7,14.4c-14.9,19.2-13.7,111.1,0,126.2,14.9,16.5,136.1,16.5,148.9,0,12.8-16.5,14.9-107,0-126.2ZM143,126.4c-9.9,12.8-104.2,12.8-115.7,0-10.6-11.8-11.6-83.2,0-98.1,11.6-14.9,104.2-14.9,115.7,0,11.6,14.9,9.9,85.3,0,98.1Z"
          />
        </g>
        <path
          className="fill-current"
          d="M107.9,81.2l-30.3,18.1c-2.5,1.5-5.6-.3-5.6-3.2v-36.1c0-2.9,3.1-4.7,5.6-3.2l30.3,18.1c2.4,1.4,2.4,4.9,0,6.4Z"
        />
      </g>
      <path
        className="fill-current"
        d="M107.9,81.2l-30.3,18.1c-2.5,1.5-5.6-.3-5.6-3.2v-36.1c0-2.9,3.1-4.7,5.6-3.2l30.3,18.1c2.4,1.4,2.4,4.9,0,6.4Z"
      />
    </svg>
  )
}

export default AppStreamIcon
